import { CLEAR_REVERT_DRAG_DROP } from './actionTypes';

const doClearRevertDragDrop = () => ({
  type: CLEAR_REVERT_DRAG_DROP
});

export { doClearRevertDragDrop };
